import 'select2/dist/js/select2.full.js'

jQuery('#billing_state, #billing_country').on('select2:open', function (e) {

    //console.log( jQuery( '.select2-container--open .select2-search input' ) )
    jQuery( '.select2-container--open .select2-search input' ).attr( 'placeholder', 'Search...' )

});

jQuery('.gform_wrapper .ginput_container_select select').select2({
    width: '100%',
})

jQuery('.product__modal .variations select').select2({
    width            : '200px',
    dropdownCssClass : 'no-search'
}).on('select2:select', function( event ){

    jQuery( '.add_to_cart_button', jQuery( event.target ).closest('form') ).text('Add to cart')

})

// jQuery('.product__modal .variations select').each(function(){
//
//     console.log( jQuery( this ) )
//
//     jQuery( this ).select2({
//         width            : '200px',
//         dropdownCssClass : 'no-search'
//     }).on('select2:select', function( event ){
//
//         jQuery( '.add_to_cart_button', jQuery( event.target ).closest('form') ).text('Add to cart')
//
//     })
//
// })
